// One precedence rule for every CMS theme. Generated page text is deliberately
// kept separate from explicit metaTitle/metaDescription/metaImage settings.
const text = value => typeof value === 'string' && value.trim() ? value.trim() : null;

function localizedFields(value, lang, rootLang, keys) {
    const result = {};
    const overlay = lang !== rootLang && value?.[lang];
    for (const key of keys) result[key] = text(overlay?.[key]) || text(value?.[key]);
    return result;
}

export function resolveSiteMetadata(context = {}, automatic = {}, pageSeo = null) {
    const rootLang = context.org?.language || 'fr';
    const lang = context.langValue || context.lang?.value || (typeof context.lang === 'string' && context.lang) || rootLang;
    const defaults = localizedFields(context.config?.seo || context.org?.web?.seo, lang, rootLang, ['title', 'description', 'image']);
    const page = localizedFields(context.page, lang, rootLang, ['metaTitle', 'metaDescription', 'metaImage']);
    const explicit = localizedFields(pageSeo, lang, rootLang, ['metaTitle', 'metaDescription', 'metaImage']);
    return {
        title: explicit.metaTitle || page.metaTitle || defaults.title || automatic.title,
        description: explicit.metaDescription || page.metaDescription || defaults.description || automatic.description,
        image: explicit.metaImage || page.metaImage || defaults.image || automatic.image,
    };
}
